module.exports = __webpack_public_path__ + "img/close-mcp.61373ffd.png";